import { Noun, PluralNoun, SingularNoun } from '../../types'
import блядь from './блядь'
import пизда from './пизда'
import пиздец from './пиздец'
import сука from './сука'
import хуй from './хуй'
import долбоёб from './долбоёб'
import наебалово from './наебалово'
import хуета from './хуета'
import хуйня from './хуйня'
import заебумба from './заебумба'

const nouns: Array<SingularNoun | PluralNoun | Noun> = [
  блядь,
  долбоёб,
  заебумба,
  наебалово,
  пизда,
  пиздец,
  сука,
  хуета,
  хуй,
  хуйня,
]

export default nouns
